"use client";
import { Skeleton } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { DataInputParams } from "./inputType";
import { GetDataInputElement, getValueLabel, getValueList } from "./inputFunction";
import { Debug } from "@/util/debug";
import { useEffect, useState } from "react";
import { TransitionType } from "../layoutType";
const getValue = (t: TransitionType, params: DataInputParams, value: any) => {
  const tempValueList = getValueList("set", params);
  const tempParamsValue = params.fixedValue ?? value;
  return tempValueList
    ? getValueLabel(tempParamsValue, tempValueList)
    : (params.transition ?? false)
      ? t(tempParamsValue)
      : tempParamsValue;
};
export default function Display(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const [value, setValue] = useState(getValue(t, params, params.value));
  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setValue"] = (value: any) => {
        setValue(getValue(t, params, value));
      };
    }
  }

  useEffect(() => {
    setValue(getValue(t, params, params.value));
  }, [params.fixedValue, params.value, params.valueList, params.transition]);
  if (value == null || value == undefined) {
    return <Skeleton loading={params.loading ?? false}>{(params.loading ?? false) ? "blank" : " "}</Skeleton>;
  } else {
    //Debug(params);
    const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
    const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
    const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
    const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
    return (
      <Skeleton loading={params.loading ?? false} className={"field_" + params.name}>
        {prev}
        {unitPrev}
        {value}
        {unit}
        {next}
      </Skeleton>
    );
  }
}
